import React from 'react';
import { Link } from 'react-router-dom';

import paths from '../../../navigation/paths';
import {storageDomain} from "../../../constants";
import styles from './CategoryPreview.module.scss';

type Props = {
    name: string;
    categoryPath: string;
    imagePath?: string,
};

const CategoryPreview = ({ categoryPath, name, imagePath }: Props) => {
    return (
        <Link to={`${paths.reviewCatalog}/${categoryPath}`}>
            <span className={styles.CategoryPreview}>
                <span className={styles.CategoryPreview__name}>{name}</span>
                {imagePath && <img
                    className={styles.CategoryPreview__image}
                    src={storageDomain + imagePath}
                />}
            </span>
        </Link>
    );
};

export default CategoryPreview;
